import * as React from "react"

export default function MotorikStripeIcon(props) {
  return (
    <svg
      width={152}
      height={68}
      viewBox="0 0 152 68"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect x={63} y={21} width={26} height={26} rx={13} fill="#fff" />
      <rect
        x={62}
        y={20}
        width={28}
        height={28}
        rx={14}
        stroke="#C7C7C7"
        strokeOpacity={0.32}
        strokeWidth={2}
      />
      <path
        d="M70 34h6m6 0h-6m0 0v-6m0 6v6"
        stroke="#464646"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <rect width={68} height={68} rx={34} fill="#10110F" />
      <path
        d="M42 18h-.15L34 25.886 26.15 18H26l-8 8v24h8.15V29.071L34 36.957l7.85-7.886V50H50V26l-8-8z"
        fill="#fff"
      />
      <rect x={84} width={68} height={68} rx={34} fill="#625BF6" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M136 34.249c0-2.56-1.24-4.58-3.61-4.58-2.38 0-3.821 2.02-3.821 4.56 0 3.01 1.7 4.53 4.14 4.53 1.19 0 2.09-.27 2.77-.65v-2c-.68.34-1.46.55-2.45.55-.97 0-1.83-.34-1.94-1.52h4.89c0-.131.02-.65.02-.89H136zm-4.936-.95c0-1.13.69-1.6 1.32-1.6.61 0 1.26.47 1.26 1.6h-2.58zm-6.35-3.63c-.98 0-1.609.46-1.96.78l-.13-.62h-2.204v11.66l2.5-.53.01-2.83c.36.26.89.63 1.77.63 1.79 0 3.42-1.435 3.42-4.61-.01-2.9-1.66-4.48-3.41-4.48h.004zm-.6 6.89c-.59 0-.939-.21-1.18-.47l-.01-3.71c.26-.29.62-.49 1.19-.49.91 0 1.54 1.02 1.54 2.33 0 1.34-.62 2.34-1.54 2.34zm-7.134-7.48l2.51-.539v-2.03l-2.51.53v2.04zm0 .76h2.51v8.75h-2.51v-8.75zm-2.69.74l-.16-.74h-2.161v8.751h2.5v-5.93c.59-.77 1.59-.63 1.9-.52v-2.3c-.32-.12-1.489-.34-2.079.739zm-5-2.915l-2.44.521-.01 8.01c0 1.48 1.11 2.57 2.59 2.57.82 0 1.42-.15 1.75-.33v-2.03c-.32.13-1.9.59-1.9-.89v-3.546h1.9v-2.13h-1.901l.011-2.175zm-6.76 4.71c0-.39.32-.539.85-.539a5.584 5.584 0 012.479.64v-2.346c-.83-.33-1.65-.46-2.479-.46-2.03 0-3.38 1.06-3.38 2.83 0 2.76 3.8 2.32 3.8 3.511 0 .46-.4.61-.96.61-.83 0-1.89-.34-2.73-.8v2.38c.93.4 1.871.565 2.73.565 2.08 0 3.511-1.03 3.511-2.82-.01-2.98-3.821-2.45-3.821-3.57z"
        fill="#fff"
      />
      <rect x={63} y={21} width={26} height={26} rx={13} fill="#fff" />
      <rect
        x={62}
        y={20}
        width={28}
        height={28}
        rx={14}
        stroke="#fff"
        strokeOpacity={0.32}
        strokeWidth={2}
      />
      <path
        d="M70 34h6m6 0h-6m0 0v-6m0 6v6"
        stroke="#464646"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
